import { DocumentType } from '@synergy/models';

export const geDocumentTypeFromString = (documentType: string): DocumentType => {
    const documentTypeKey = Object.keys(DocumentType).find(key => key.toUpperCase() === documentType.toUpperCase());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (DocumentType as any)[documentTypeKey ?? 0];
};
